/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { PartnerProgramInfoVO } from './PartnerProgramInfoVO';
import { PhoneInfoVO } from './PhoneInfoVO';
import { SecureFlightPassengerInfoVO } from './SecureFlightPassengerInfoVO';

export interface CompanionInfoVO {
  basicCompanionData?: SecureFlightPassengerInfoVO;
  /**
   * SFPD-matching indicator
   */
  isSFPDMatch?: boolean;
  /**
   * SFPD-on-file indicator
   */
  isSFPDOnFile?: boolean;
  loyaltyProgram?: PartnerProgramInfoVO;
  phone?: PhoneInfoVO;
  /**
   * sequence number from database
   */
  sequenceNumber?: string;
}
